module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABgSURBVGiB7dZBDoAgDARANP6VN/Fa+YA9Va2GmSMEyJI02dYASNiijTHGebXeew/PVDiyF0RB7xZ93P7G408SoFp6Br421ACsRRvVRpMEqKaNAvBr2qg2miRANW0UYG0TGLsb0Jm6rMEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-list.png
// module id = htWL
// module chunks = 269